module.exports = "/packs/media/images/assetovertime-ed083bf27ba24c066b4b571724f0f6b7.png";